export default "__VITE_ASSET__BQPIC4dw__"